<div class="container">
  <h1> Developer Edit Mode </h1>
  <p> While this project is under active development and some key features are missing from the proper UI this view will
    exist to let you tweak and update your character by editing the raw JSON</p>
  <strong>You can mess up your character and cause unusual behavior. Please save your character before making changes</strong>
  <textarea [(ngModel)]="raw"></textarea>
  <button mat-raised-button (click)="save()" color="warn"> Save </button>
  <div class="toggle-row">
    <mat-slide-toggle [checked]="gameService.getLegacyLayout()" (change)="gameService.toggleLegacyLayout()">Legacy Ability Cards</mat-slide-toggle>
  </div>
</div>
<div class="changelog container">
  <h1>Change Log</h1>
  <dl>
    <dt><strong>Version 1.405</strong> - 10/06/2026</dt>
    <dd>Added a Print button that lays out a clean, ink-friendly version of the sheet for printing — handy for pencil-and-paper play when you are offline</dd>
    <dd>Condensed the printed sheet so a character fits far fewer pages: Hit Dice, Hit Points, Armor Class, and to-hit collapse into a single combat bar, and sections print two columns wide</dd>
    <dd>The printed sheet now includes your full experience history as a dated ledger of XP entries</dd>
    <dd>On the printed sheet, spells are a single Spells Known table — each spell, its level, and how many slots it is prepared in — covering every spell level rather than only the first</dd>
    <dd>Updated Angular, Angular Material, and other dependencies</dd>
    <dt><strong>Version 1.404</strong> - 09/23/2026</dt>
    <dd>A prime requisite of 18 now grants a +15% experience bonus, a third tier above the existing +5% and +10%</dd>
    <dt><strong>Version 1.403</strong> - 08/02/2026</dt>
    <dd>Added a Bestiary to the adventure log — each creature is a card with a name, picture, description, and stats</dd>
    <dd>Backpack slots are now shaded in fives, so you can see at a glance what is buried at the bottom of the pack</dd>
    <dd>Fixed Sack, Small defaulting to 10 slots instead of 5</dd>
    <dd>Fixed refreshing the adventure log throwing you back to the character list</dd>
    <dd>Long lines on the overview cards no longer get cut off with no way to read them — hover for the full text</dd>
    <dd>Hovering a profession now shows its definition from Appendix A instead of burying it in your notes</dd>
    <dd>Corrected profession names and definitions against the rulebook, fixing text that had been garbled ("crasman" is now "craftsman")</dd>
    <dd>Player and Playwright are now separate professions on the generation table, as the book has them</dd>
    <dd>Added Quirk (your identifying quality) to the attributes section, chosen from the book's list or typed in freely</dd>
    <dd>Character generation no longer writes anything into your notes — everything it rolls now has its own field on the sheet</dd>
    <dd>Weight is now calculated from strength, constitution, sex, and a light / average / heavy weight class rather than typed in</dd>
    <dd>Existing characters keep the weight class closest to the weight they already had</dd>
    <dd>Height and weight now share a line on the sheet, and stay separate fields when editing</dd>
    <dd>Upgraded Angular and Angular Material from 19 to 22</dd>
    <dt><strong>Version 1.402</strong> - 08/02/2026</dt>
    <dd>Known languages are now a list of separate entries shown as chips, so every language your character speaks is visible instead of trailing off</dd>
    <dd>Existing languages typed into one field are split into separate entries automatically</dd>
    <dd>Added primary handedness to the stats section, rolled automatically for generated characters</dd>
    <dd>Added dental status to the attributes section</dd>
    <dd>Added encumbrance level to the movement card</dd>
    <dd>Fixed movement rating for a load of exactly one third of maximum, which was rated Medium instead of Light</dd>
    <dd>Generated characters now record sex capitalized</dd>
    <dd>The account menu now shows which email you are signed in as</dd>
    <dt><strong>Version 1.401</strong> - 07/21/2026</dt>
    <dd>Fixed the tab title randomly reverting to the character's name after navigating away from the sheet</dd>
    <dt><strong>Version 1.400</strong> - 07/20/2026</dt>
    <dd>Added optional free accounts (email &amp; password) with cloud backup — the tool remains fully usable anonymously</dd>
    <dd>Characters now sync to the cloud when signed in, with an offline cache</dd>
    <dd>Added Campaigns as the home for your characters, with a shared per-campaign adventure log (sessions &amp; notes)</dd>
    <dd>Added a character switcher and a campaign-scoped roster with alive/dead status</dd>
    <dd>Signing in for the first time automatically saves your current character into a new campaign</dd>
    <dd>Hirelings are now first-class campaign characters</dd>
    <dd>Added a pop-out party stat summary window</dd>
    <dd>Moved character experience to its own page, with multiclass support and prime-requisite display</dd>
    <dd>Added password reset and change-password</dd>
    <dd>Account-aware navigation and theming polish, plus new helm/skull/church icons</dd>
    <dt><strong>Version 1.302</strong> - 06/28/2026</dt>
    <dd>Updated footer link to the correct name</dd>
    <dt><strong>Version 1.301</strong> - 03/14/2026</dt>
    <dd>Replaced prebuilt Material purple theme with custom light/dark mode support</dd>
    <dd>Redesigned ability card layout with option to toggle legacy ability cards</dd>
    <dd>Replaced chunky edit/delete FABs on item, container, and spell rows with click-to-edit</dd>
    <dd>Moved delete actions inside edit dialogs for items, containers, and spells</dd>
    <dd>Replaced mini-FABs with subtle icon buttons across inventory, purse, spells, and spell slots</dd>
    <dd>Added inline +/- quantity buttons on item rows</dd>
    <dd>Added capacity field to equipment data for Backpack, Sack Large, Sack Small, and Saddle Bags</dd>
    <dd>Container typeahead now auto-populates capacity when selecting equipment</dd>
    <dd>Marked sacks and Saddle Bags as slingable containers</dd>
    <dt><strong>Version 1.300</strong> - 02/16/2026</dt>
    <dd>Added character generator with random ability rolling, name generation, and physical attributes</dd>
    <dd>Added equipment library with searchable autocomplete for items and containers</dd>
    <dd>Added equipment loadout presets for new characters</dd>
    <dd>Added searchable spell list for Magic User and Cleric spells</dd>
    <dd>Added hireling generation from the hirelings view</dd>
    <dd>Upgraded from Angular 18 to Angular 19</dd>
    <dd>Upgraded RxJS from 6 to 7, TypeScript to 5.8</dd>
    <dd>Migrated all components to standalone (removed NgModules)</dd>
    <dd>Migrated templates to modern control flow (&#64;if/&#64;for)</dd>
    <dd>Replaced tslint with ESLint</dd>
    <dd>Removed deprecated dependencies (Protractor, Karma, tslint, codelyzer)</dd>
    <dt><strong>Version 1.201</strong> - 01/07/2025</dt>
    <dd>Updated name to Primeval Arcana</dd>
    <dt><strong>Version 1.200</strong> - 09/08/2024</dt>
    <dd>Upgraded from Angular 9 to Angular 18</dd>
    <dt><strong>Version 1.105</strong> - 07/29/2024</dt>
    <dd>Allowed the importing of characters as hirelings</dd>
    <dt><strong>Version 1.104</strong> - 4/3/2022</dt>
    <dd>AddedCleric Deity Section</dd>
    <dd>Added Turning events</dd>
    <dd>Added Prayer and turning slot tracking</dd>
    <dt><strong>Version 1.103</strong> - 4/3/2022</dt>
    <dd>Cleric Spell overhaul including all included spells and descriptions</dd>
    <dt><strong>Version 1.102</strong> - 4/3/2022</dt>
    <dd>Bumping dependency versions</dd>
    <dd>Updating System Shock, Precision Thrown Distance, and other items to consider prime requisite bonuses</dd>
    <dt><strong>Version 1.101</strong> - 10/8/2020</dt>
    <dd>Added AC to the HUD</dd>
    <dd>Large Multiclassing Feature enabled</dd>
    <dt><strong>Version 1.100</strong> - 9/5/2020</dt>
    <dd>Large Multiclassing Feature enabled</dd>
    <dd>A few copy updates</dd>
    <dd>Enabled selection of any ability as prime requisite</dd>
    <dd>Created changelog</dd>
    <dd>Arbitrarily selected 1.100 because I'm lazy and didn't version things from the onset</dd>
    <dd>Added version to header</dd>
  </dl>
</div>
